module.exports = "<div class=modal tabindex=-1 role=dialog> <div class=modal-dialog> <cn-round-form modal=true title-text=round.salary.edit.title button-text=cenceo.edit data=data questionnaires=data.questionnaires performance-review-rounds=data.assessment_rounds on-submit=submit on-change=change on-reset=reset></cn-round-form> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-round/salary-round.edit.modal.html
 ** module id = 227
 ** module chunks = 0
 **/